import * as missions from "@/store/missions/asyncActions"
import { Mission } from "@/store/missions/models"
import classNames from "classnames"
import _ from "lodash"
import React from "react"
import { connect } from "react-redux"
import MissionItemTypes from "./MissionItemTypes"
import style from "./style.scss"

export interface MissionListItemProps {
  openModal: (index?: number) => void
  acceptMission: (missionUuid: string) => Promise<void>
  submitAllTaskData: (mission: Mission) => Promise<void>
  index?: number
  mission: Mission
}

const MissionListItem: React.SFC<Readonly<MissionListItemProps>> = (props) => {
  const TypeComponent = (MissionItemTypes as any)[
    props.mission.isTutorial
      ? "tutorial"
      : _.camelCase(props.mission.getStatus())
  ]

  const classes = classNames(style.missionListItem, [
    style[`missionListItem--${_.kebabCase(props.mission.getStatus())}`]
  ])

  return (
    <article className={classes}>
      <TypeComponent {...props} />
    </article>
  )
}

export default connect(
  null,
  (dispatch: any) => ({
    acceptMission: (missionUuid: string) =>
      dispatch(missions.acceptMission({ missionUuid })) as Promise<void>,
    submitAllTaskData: async (mission: Mission) =>
      dispatch(missions.submitAllTaskData(mission)) as Promise<void>
  })
)(MissionListItem)
